const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";
import * as types from "./mutation_types";

export const retrieve = ({ commit }) => {
  commit(types.USER_SHOW_TOGGLE_LOADING);
  axios
    .get(URL_BACKEND + "api-user/current/")
    .then((response) => {
      commit(types.USER_SHOW_SET_RETRIEVED, response.data);
    })
    .catch((e) => {
      commit(types.USER_SHOW_SET_ERROR, e.message);
    })
    .finally(() => {
      commit(types.USER_SHOW_TOGGLE_LOADING);
    });
};

export const reset = ({ commit }) => {
  commit(types.USER_SHOW_RESET);
};
